import React, { Fragment, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setFieldProperty,
  setFormValue,
  resetLookupTable,
  getUserDefinedLookupList,
  setProcessing,
  deleteDatasetField,
  saveDatasetFields,
} from "../../../redux/slices/datasetviewpageslice";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { dataTypes, notificationDurationMiddle } from "../../../lib/utils";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Checkbox, Input, RadioButton } from "@progress/kendo-react-inputs";
import { tr } from "date-fns/locale";
import { apiErrorsHandler, getErrorMessages } from "../../../api/httpclient";
import { addNotification } from "../../../redux/slices/notificationsslice";
import { useNavigate } from "react-router-dom";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Button, DropDownButton } from "@progress/kendo-react-buttons";
import {
  hideAppDialog,
  setAppDialog,
} from "../../../redux/slices/appdialogslice";

export const IsAutoCell = (props) => {
  const dispatch = useDispatch();
  const { dataItem } = props;
  const field = dataItem;

  return (
    <Fragment>
      {field.IsAuto ? (
        <td>
          <RadioButton
            id={`IsAuto.${field.Id}`}
            name={`IsAuto.${field.Id}`}
            checked={field.IsAuto}
            disabled
          />
        </td>
      ) : (
        <td></td>
      )}
    </Fragment>
  );
};

export const NameCell = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.datasetViewPage);

  const { dataItem } = props;
  const field = dataItem;

  return (
    <td>
      <Input
        value={field.Name || ""}
        readOnly={pageState.formValues.CreateFrom === "fromdb"}
        onChange={(e) => {
          dispatch(
            setFieldProperty({
              id: field.Id,
              prop: "Name",
              value: e.value,
            }),
          );
        }}
      />
    </td>
  );
};

export const TitleCell = (props) => {
  const dispatch = useDispatch();

  const { dataItem } = props;
  const field = dataItem;

  return (
    <td>
      <Input
        value={field.Title || ""}
        onChange={(e) => {
          dispatch(
            setFieldProperty({
              id: field.Id,
              prop: "Title",
              value: e.value,
            }),
          );
        }}
      />
    </td>
  );
};

export const DataTypeCell = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.datasetViewPage);
  const { dataItem } = props;
  const field = dataItem;

  return (
    <td>
      <DropDownList
        id={`DataTypeId.${field.Id}`}
        name={`DataTypeId.${field.Id}`}
        data={dataTypes}
        dataItemKey="Id"
        textField="Title"
        disabled={pageState.formValues.CreateFrom === "fromdb" ? true : false}
        value={dataTypes.find((item) => item.Id === field.DataTypeId)}
        onChange={(e) => {
          const selectedValue = e.target.value;
          dispatch(
            setFieldProperty({
              id: field.Id,
              prop: "DataTypeId",
              value: selectedValue ? Number(selectedValue.Id) : null,
            }),
          );
          if (
            selectedValue == "5" ||
            selectedValue == 5 ||
            Number(selectedValue.Id) == 5
          ) {
            dispatch(
              setFieldProperty({
                id: field.Id,
                prop: "IsUTC",
                value: true,
              }),
            );
          } else {
            dispatch(
              setFieldProperty({
                id: field.Id,
                prop: "IsUTC",
                value: false,
              }),
            );
          }
        }}
      />
    </td>
  );
};

export const IsDecimalCell = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.datasetViewPage);
  const addDatasetFrom = pageState.formValues.CreateFrom;
  const { dataItem } = props;
  const field = dataItem;

  return (
    <Fragment>
      {!field.IsAuto && Number(field.DataTypeId) === 2 ? (
        <td>
          <Checkbox
            id={`IsDecimal.${field.Id}`}
            checked={field.IsDecimal}
            disabled={addDatasetFrom === "fromdb" ? true : false}
            onChange={(e) => {
              dispatch(
                setFieldProperty({
                  id: field.Id,
                  prop: "IsDecimal",
                  value: e.target.value,
                }),
              );
            }}
          />
        </td>
      ) : (
        <td></td>
      )}
    </Fragment>
  );
};

export const IsLookupCell = (props) => {
  const dispatch = useDispatch();
  const { dataItem } = props;
  const field = dataItem;

  return (
    <Fragment>
      {!field.IsAuto &&
      Number(field.DataTypeId) === 2 &&
      field.IsDecimal === false ? (
        <td>
          <Checkbox
            id={`IsLookup.${field.Id}`}
            checked={field.IsLookup}
            onChange={(e) => {
              dispatch(
                setFieldProperty({
                  id: field.Id,
                  prop: "IsLookup",
                  value: e.target.value,
                }),
              );
            }}
          />
        </td>
      ) : (
        <td></td>
      )}
    </Fragment>
  );
};

export const LookupTextColumnCell = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.datasetViewPage);
  const lookupTextColumns = pageState.formValues.DatasetLookupTextColumn;
  const { dataItem } = props;

  const field = dataItem; 
  useEffect(() => {
  if (
    field.LookupTextColumn === undefined &&
    field.LookupTitleColumnName
  ) {
    dispatch(
      setFieldProperty({
        id: field.Id,
        prop: "LookupTextColumn",
        value: field.LookupTitleColumnName,
      })
    );
  }
}, [dispatch, field]);

  return (
    <Fragment>
      {Number(field.DataTypeId) === 2 &&
      field.IsLookup &&
      field.IsDecimal === false ? (
        <td>
          <DropDownList
            id={`LookupTextColumn`}
            name={`LookupTextColumn`}
            data={lookupTextColumns}
            dataItemKey="Id"
            textField="Title"
            value={lookupTextColumns?.find(
              (item) => item.Id === field.LookupTextColumn,
            )}
            onChange={(e) => {
              const selectedValue = e.value;
              dispatch(
                setFieldProperty({
                  id: field.Id,
                  prop: "LookupTextColumn",
                  value: selectedValue ? selectedValue.Id : null,
                }),
              );
            }}
          />
        </td>
      ) : (
        <td></td>
      )}
    </Fragment>
  );
};

export const LookupTableCell = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.datasetViewPage);
  const lookupTables = pageState.formValues.DatasetLookupTables;

  const { dataItem } = props;
  const field = dataItem;

  const handleUndoToLookupTable = ({ id, prop }) => {
    dispatch(resetLookupTable(id, prop));
  };
  return (
    <Fragment>
      {Number(field.DataTypeId) === 2 &&
      field.IsLookup &&
      field.IsDecimal === false &&
      field.LookupId >= 0 &&
      field.LookupTextColumn !== "0" ? (
        <td>
          <DropDownList
            id={`LookupId`}
            name={`LookupId`}
            data={lookupTables}
            dataItemKey="Id"
            textField="Title"
            value={lookupTables?.find((item) => item.Id === field.LookupId)}
            onChange={(e) => {
              const selectedValue = e.value;
              dispatch(
                setFieldProperty({
                  id: field.Id,
                  prop: "LookupId",
                  value: selectedValue ? Number(selectedValue.Id) : null,
                }),
              );
            }}
          />
        </td>
      ) : Number(field.DataTypeId) === 2 &&
        field.IsLookup &&
        field.IsDecimal === false &&
        field.LookupId < 0 ? (
        <td>
          <Input
            type="text"
            id={`LookupTableTitle`}
            name={`LookupTableTitle`}
            value={field.LookupTableTitle}
            onChange={(e) =>
              dispatch(
                setFieldProperty({
                  id: field.Id,
                  prop: "LookupTableTitle",
                  value: e.value,
                }),
              )
            }
          />
          <div
            className="undo"
            onClick={(e) =>
              handleUndoToLookupTable({
                id: field.Id,
                prop: "LookupTableTitle",
              })
            }
          >
            <span className="k-icon k-i-undo"></span>
          </div>
        </td>
      ) : (
        <td></td>
      )}
      <style>
        {`.dataset-grid .undo{
                position: relative;
                float: right;
                right: 8px;
                cursor: pointer;
                margin-top:-30px;
            }
            
            `}
      </style>
    </Fragment>
  );
};

export const MaxLengthCell = (props) => {
  const dispatch = useDispatch();
  const { dataItem } = props;
  const pageState = useSelector((state) => state.datasetViewPage);
  const addDatasetFrom = pageState.formValues.CreateFrom;
  const field = dataItem;

  return (
    <Fragment>
      {Number(field.DataTypeId) === 3 ? (
        <td>
          <Input
            type="number"
            value={field.TextMaxLength}
            readOnly={addDatasetFrom === "fromdb" ? true : false}
            onChange={(e) => {
              dispatch(
                setFieldProperty({
                  id: field.Id,
                  prop: "TextMaxLength",
                  value: Number(e.value),
                }),
              );
            }}
          />
        </td>
      ) : (
        <td></td>
      )}
    </Fragment>
  );
};

export const DeleteRowCell = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.datasetViewPage);
  const { dataItem, t } = props;
  const handleDelete = () => {
    dispatch(
      setAppDialog({
        isVisible: true,
        className: "dataset-page-are-you-sure",
        title: t("datasets.datasetview.warning"),
        content: t("datasets.datasetview.deletefield"),
        actions: {
          yesButton: {
            title: t("datasets.datasetview.yes"),
            handler: () => {
              dispatch(hideAppDialog());
              const updatedFields = pageState.formValues.DatasetFields.filter(
                (item) => item.Id !== dataItem.Id,
              );

              dispatch(
                setFormValue({
                  id: "DatasetFields",
                  value: updatedFields.length > 0 ? updatedFields : [], // ensure array
                }),
              );

              // Clear edit ID only if it's the deleted row
              if (pageState.formValues.DatasetEditRowId === dataItem.Id) {
                dispatch(
                  setFormValue({
                    id: "DatasetEditRowId",
                    value: null,
                  }),
                );
              }
            },
          },
          noButton: { title: t("datasets.datasetview.no") },
        },
      }),
    );
  };
  return (
    <td>
      <Button
        icon="trash"
        type="button"
        onClick={handleDelete}
        title={t("datasets.datasetview.delete_row")}
      />
    </td>
  );
};

export const ActionCell = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const pageState = useSelector((state) => state.datasetViewPage);
  const { dataItem } = props;

  const normalizeField = (field, lookupTables) => {
    const { LookupTitleColumnName, LookupTableName, ...rest } = field;
    debugger;
    let normalized = {
      ...rest,
      LookupTextColumn: field.LookupTextColumn ?? LookupTitleColumnName ?? "",
      LookupTableTitle: field.LookupTableTitle ?? LookupTableName ?? "",
    };

    // case 1: LookupTableTitle is empty → get from DatasetLookupTables
    if (
      normalized.LookupTableTitle === "" &&
      normalized.LookupId &&
      lookupTables
    ) {
      const lookupTable = lookupTables.find(
        (lt) => lt.Id === normalized.LookupId,
      );
      if (lookupTable) normalized.LookupTableTitle = lookupTable.Title;
    }

    // case 2: LookupTableTitle is "New" → replace with LookupTableName
    if (normalized.LookupTableTitle === "New") {
      normalized.LookupTableTitle = field.LookupTableName ?? "";
    }

    return normalized;
  };

  const handleSaveSuccess = (dataItem, response, pageState, dispatch, t) => {
    dispatch(
      addNotification({
        text: t("datasets.datasetview.fieldsaved"),
        type: "success",
        closable: true,
        duration: 3,
        position: "topRight",
      }),
    );

    const newId = response?.data?.Data?.DataFieldId;
    const lkpId = response?.data?.Data?.LookupId;

    let updatedFields = pageState.formValues.DatasetFields;

    //  Update lookup tables if we got a valid lkpId
    if (lkpId) {
      let updatedLkps = [...(pageState.formValues.DatasetLookupTables || [])];

      if (!updatedLkps.some((lkp) => lkp.Id === lkpId)) {
        updatedLkps.push({ Id: lkpId, Title: dataItem.LookupTableName });
      }

      dispatch(
        setFormValue({
          id: "DatasetLookupTables",
          value: updatedLkps,
        }),
      );
    }

    // Case 1: New record (negative temp Id) → replace with server Id
    if (dataItem.Id < 0 && newId) {
      updatedFields = updatedFields.map((f) =>
        f.Id === dataItem.Id
          ? {
              ...f,
              Id: newId,
              LookupId: lkpId,
              LookupData: pageState.formValues.DatasetLookupTables,
            }
          : f,
      );
    }

    // // Case 2: Existing Lookup → update LookupId

    if (
      dataItem.Id > 0 &&
      dataItem.IsLookup &&
      dataItem.LookupId < 0 &&
      lkpId
    ) {
      updatedFields = updatedFields.map((f) =>
        f.Id === dataItem.Id ? { ...f, LookupId: lkpId } : f,
      );
    }

    // Update fields
    dispatch(setFormValue({ id: "DatasetFields", value: updatedFields }));

    // Remove dirty flag
    const updatedDirtyRowIds = pageState.formValues.DirtyRowIds?.filter(
      (id) => id !== dataItem.Id,
    );
    dispatch(setFormValue({ id: "DirtyRowIds", value: updatedDirtyRowIds }));
  };

  const handleSaveError = (err, dispatch, navigate) => {
    dispatch(setProcessing({ processing: false }));

    const handleResponseReceived = (state, dispatch, navigate, payload) => {
      let errorMessages = payload?.data?.ErrorMessages;

      if (!errorMessages || errorMessages.length === 0) {
        dispatch(
          addNotification({
            text: t("datasets.datasetview.loading_error"),
            type: "error",
            closable: true,
            duration: 3,
            position: "topRight",
          }),
        );
      } else {
        errorMessages = getErrorMessages(errorMessages, 1);
        dispatch(
          addNotification({
            text: errorMessages[0],
            type: "error",
            closable: true,
            duration: 3,
            position: "topRight",
          }),
        );
      }
    };

    const handleUnhandled = () => {
      dispatch(
        addNotification({
          text: t("datasets.datasetview.unknown_error"),
          type: "error",
          closable: true,
          duration: 3,
          position: "topRight",
        }),
      );
    };

    apiErrorsHandler({}, dispatch, navigate, err, "/", {
      responseReceived: handleResponseReceived,
      unhandled: handleUnhandled,
    });
  };

  const handleSave = (dataItem, t) => {
    dispatch(
      setAppDialog({
        isVisible: true,
        className: "dataset-page-are-you-sure",
        title: t("datasets.datasetview.warning"),
        content: t("datasets.datasetview.updatefield"),
        actions: {
          yesButton: {
            title: t("datasets.datasetview.yes"),
            handler: () => {
              dispatch(hideAppDialog());
              debugger;
              const updatedDataConfigFields = [];
              const lookupTables = pageState.formValues.DatasetLookupTables;

              // Always add main item
              updatedDataConfigFields.push(
                normalizeField(dataItem, lookupTables),
              );

              // Add related lookup field(s)
              if (dataItem.IsLookup) {
                const relatedField = pageState.formValues.DatasetFields.filter(
                  (item) => item.Name === dataItem.LookupTextColumn,
                );
                if (relatedField?.length > 0) {
                  updatedDataConfigFields.push(
                    ...relatedField.map((f) => normalizeField(f, lookupTables)),
                  );
                }
              }

              // Save to backend
              dispatch(
                saveDatasetFields(
                  pageState.formValues.Id,
                  updatedDataConfigFields,
                  t,
                ),
              ).then(
                (response) =>
                  handleSaveSuccess(dataItem, response, pageState, dispatch, t),
                (err) => handleSaveError(err, dispatch, navigate),
              );
            },
          },
          noButton: { title: t("datasets.datasetview.no") },
        },
      }),
    );
  };

  const handleDelete = (dataItem, t) => {
    dispatch(
      setAppDialog({
        isVisible: true,
        className: "dataset-page-are-you-sure",
        title: t("datasets.datasetview.warning"),
        content: t("datasets.datasetview.deletefield"),
        actions: {
          yesButton: {
            title: t("datasets.datasetview.yes"),
            handler: () => {
              dispatch(hideAppDialog());
              if (dataItem.Id < 0) {
                const updatedFields = pageState.formValues.DatasetFields.filter(
                  (item) => item.Id !== dataItem.Id,
                );

                dispatch(
                  setFormValue({
                    id: "DatasetFields",
                    value: updatedFields,
                  }),
                );

                const updatedDirtyRowIds =
                  pageState.formValues.DirtyRowIds?.filter((id) => {
                    return id !== dataItem.Id;
                  });
                dispatch(
                  setFormValue({
                    id: "DirtyRowIds",
                    value: updatedDirtyRowIds,
                  }),
                );

                if (pageState.formValues.DatasetEditRowId === dataItem.Id) {
                  dispatch(
                    setFormValue({
                      id: "DatasetEditRowId",
                      value: null,
                    }),
                  );
                }
                return;
              }

              dispatch(deleteDatasetField(dataItem.Id, t)).then(
                (response) => {
                  dispatch(
                    addNotification({
                      text: t("datasets.datasetview.fielddeleted"),
                      type: "success",
                      closable: true,
                      duration: 3,
                      position: "topRight",
                    }),
                  );

                  const updatedFields =
                    pageState.formValues.DatasetFields.filter(
                      (item) => item.Id !== dataItem.Id,
                    );

                  dispatch(
                    setFormValue({
                      id: "DatasetFields",
                      value: updatedFields,
                    }),
                  );

                  const updatedDirtyRowIds =
                    pageState.formValues.DirtyRowIds?.filter(
                      (id) => id !== dataItem.Id,
                    );
                  dispatch(
                    setFormValue({
                      id: "DirtyRowIds",
                      value: updatedDirtyRowIds,
                    }),
                  );

                  if (pageState.formValues.DatasetEditRowId === dataItem.Id) {
                    dispatch(
                      setFormValue({
                        id: "DatasetEditRowId",
                        value: null,
                      }),
                    );
                  }
                },
                (err) => {
                  //hide loader
                  dispatch(setProcessing({ processing: false }));

                  const handleResponseReceived = (
                    state,
                    dispatch,
                    navigate,
                    payload,
                  ) => {
                    let errorMessages = payload?.data?.ErrorMessages;

                    //notify with error
                    if (!errorMessages || errorMessages.length == 0)
                      dispatch(
                        addNotification({
                          text: t("notifications.loading_errormessage"),
                          type: "error",
                          closable: true,
                          duration: 3,
                          position: "topRight",
                        }),
                      );
                    else {
                      errorMessages = getErrorMessages(errorMessages, 1);
                      dispatch(
                        addNotification({
                          text: errorMessages[0],
                          type: "error",
                          closable: true,
                          duration: 3,
                          position: "topRight",
                        }),
                      );
                    }

                    //go home
                    //navigate("/", { replace: true });
                  };

                  const handleUnhandled = (
                    state,
                    dispatch,
                    navigate,
                    payload,
                  ) => {
                    dispatch(
                      addNotification({
                        text: t("slices.errorOccured"),
                        type: "error",
                        closable: true,
                        duration: 3,
                        position: "topRight",
                      }),
                    );
                    //navigate("/", { replace: true });
                  };

                  apiErrorsHandler({}, dispatch, navigate, err, "/", {
                    responseReceived: handleResponseReceived,
                    unhandled: handleUnhandled,
                  });
                },
              );
            },
          },
          noButton: { title: t("datasets.datasetview.no") },
        },
      }),
    );
  };
  const actionItems = [
    {
      text: t("datacorrection.save"),
      icon: "save",
      id: "Save",
    },
    {
      text: t("datasets.datasetview.delete2"),
      icon: "delete",
      id: "Delete",
    },
  ];
  return (
    <td className="k-command-cell" style={{ textAlign: "center" }}>
      <DropDownButton
        items={actionItems}
        icon="more-horizontal"
        fillMode="flat"
        size="small"
        popupSettings={{ animate: true }}
        title={t("datasets.datasetview.actions")}
        onItemClick={(e) => {
          if (e.item.id === "Save") handleSave(dataItem, t);
          if (e.item.id === "Delete") handleDelete(dataItem, t);
        }}
      />
    </td>
  );
};

const DatasetGrid = (props) => {
  //#region state
  const { formValues } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pageState = useSelector((state) => state.datasetViewPage);
  const { t } = useTranslation();
  const gridRef = useRef(null);
  const containerRef = useRef(null);
  //#endregion

  //#region functions
  const handleOnChange = (id, value, regex) => {
    dispatch(
      setFormValue({ id, value, regex: regex ? regex.toString() : null }),
    );
  };
  const handleOnRowClick = (event) => {
    handleOnChange("DatasetEditRowId", event.dataItem.Id);
  };
  const handleItemChange = (event) => {
    const inEditID = event.dataItem.Id;
    const field = event.field || "";
    const newData = pageState.formValues.DatasetFields.map((item) =>
      item.Id === inEditID
        ? {
            ...item,
            [field]: event.value,
          }
        : item,
    );
    handleOnChange("DatasetFields", newData);
  };

  const handleOnAddNew = () => {
    const currentFields = pageState.formValues.DatasetFields || [];

    // Find the minimum negative Id in current fields (e.g., -1, -2, etc.)
    const minNegativeId = currentFields
      .filter((item) => Number(item.Id) < 0)
      .reduce((min, item) => Math.min(min, Number(item.Id)), 0);

    const newField = {
      Id: minNegativeId - 1 || -1, // Start at -1 if none exist
      Name: "",
      Title: "",
      DataTypeId: 3,
      IsDecimal: false,
      IsLookup: false,
      LookupTitleColumnName: null,
      LookupId: 0,
      LookupTable: null,
      TextMaxLength: 100,
      IsAuto: false,
      IsUTC: false,
    };

    const newData = [...currentFields, newField];

    dispatch(setFormValue({ id: "DatasetFields", value: newData }));
    dispatch(setFormValue({ id: "DatasetEditRowId", value: newField.Id }));

    // Defer scrolling until after render
    setTimeout(() => {
      const gridElement = gridRef.current?.element;
      if (gridElement) {
        const scrollableDiv = gridElement.querySelector(".k-grid-content");
        if (scrollableDiv) {
          scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
        }
      }
    }, 100); // Small delay to wait for DOM update
  };
  //#endregion

  useEffect(() => {
    let lookupTextArr = [{ Id: "0", Title: t("datasets.create.select") }];
    formValues.DatasetFields?.forEach((field) => {
      if (Number(field.DataTypeId) === 3) {
        lookupTextArr.push({ Id: field.Name, Title: field.Name });
      }
    });
    dispatch(
      setFormValue({
        id: "DatasetLookupTextColumn",
        value: lookupTextArr,
      }),
    );
  }, [formValues.DatasetFields]);

  useEffect(() => { 
    dispatch(getUserDefinedLookupList(t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("datasets.create.unknown_error")];
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
          }

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("datasets.create.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );
  }, [t]);

  return (
    <div className="dataset-grid" ref={containerRef}>
      <Grid
        ref={gridRef}
        data={formValues.DatasetFields.map((item) => ({
          ...item,
          inEdit: item.Id === formValues.DatasetEditRowId,
        }))}
        scrollable="scrollable"
        resizable={true} // Enable column resizing
        style={{ height: "400px" }}
        editField="inEdit"
        onRowClick={handleOnRowClick}
        onItemChange={handleItemChange}
      >
        <GridToolbar>
          <Button
            style={{ float: "right" }}
            title={t("datasets.datasetview.add_new")}
            onClick={handleOnAddNew}
            type="button"
          >
            {t("datasets.datasetview.add_new")}
          </Button>
        </GridToolbar>
        {pageState.formValues.CreateFrom === "fromdb" && (
          <GridColumn
            field="Id"
            title={t("datasets.datasetview.auto")}
            editor="boolean"
            cell={IsAutoCell}
            width={100}
          />
        )}
        <GridColumn
          field="Name"
          title={t("datasets.create.name1")}
          cell={NameCell}
          width={150}
        />

        <GridColumn
          field="Title"
          title={t("datasets.datasetview.title")}
          cell={TitleCell}
          width={150}
        />
        <GridColumn
          field="Type"
          title={t("datasets.create.type1")}
          editor="text"
          cell={DataTypeCell}
          width={150}
        />
        {/* <GridColumn
          field="IsUTC"
          title="IsUTC"
          editor="boolean"
          cell={IsUtcCell}
          width={150}
        /> */}
        <GridColumn
          field="IsDecimal"
          title={t("datasets.create.isdecimal")}
          editor="boolean"
          cell={IsDecimalCell}
          width={150}
        />
        <GridColumn
          field="IsLookup"
          title={t("datasets.create.islookup")}
          editor="boolean"
          cell={IsLookupCell}
          width={150}
        />
        <GridColumn
          field="LookupTextColumn"
          title={t("datasets.create.islookuptext")}
          editor="text"
          cell={LookupTextColumnCell}
          width={150}
        />
        <GridColumn
          field="LookupTable"
          title={t("datasets.create.lookuptable")}
          editor="text"
          cell={LookupTableCell}
          width={150}
        />
        <GridColumn
          field="TextMaxLength"
          title={t("datasets.create.maxlength")}
          editor="numeric"
          cell={MaxLengthCell}
          width={150}
        />

        <GridColumn
          title={t("datasets.datasetview.actions")}
          cell={ActionCell}
          width={70}
        />
      </Grid>
      <style>
        {`
            .dataset-grid .k-grid-toolbar{
              justify-content:flex-end;
            }
              
            @media (max-width: 1024px) {
              .dataset-grid .k-grid-toolbar {
                display: none;
              }
            }
        `}
      </style>
    </div>
  );
};

export default DatasetGrid;
